import React, { FC, useState } from 'react'
import { Container, Grid, makeStyles, Typography } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { RouteLocationProps } from '../../routes/mobilbase';
import DeviceLogDataFetcher from '../../components/helpers/DeviceLogDataFetcher';
import useDevicelogStyles from '../../hooks/DevicelogHook';

const DeviceLog: FC = () => {
  const classes = useDevicelogStyles();
  const routeLocation = useLocation<RouteLocationProps>();
  const {selectedLocationId, selectedDeviceId, selectedDeviceName} = (routeLocation.state) ? routeLocation.state : new RouteLocationProps();

  return (
    <Container maxWidth={false}>
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          Hændelseslog - {((selectedDeviceName) ? selectedDeviceName : "INGEN VALGT")}
        </Typography>
        <div className={classes.grid}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <DeviceLogDataFetcher locationId={selectedLocationId} deviceId={selectedDeviceId}/>
            </Grid>
          </Grid>
        </div>
      </div>
    </Container>  
  );
}

export default DeviceLog;